// extracted by mini-css-extract-plugin
module.exports = {"rotateIcon":"EmptyTimelineEntry-module--rotateIcon--3VqN5"};